import React, {Component} from 'react';
import {Row, Col, FormGroup, ControlLabel, Form, FormControl} from "react-bootstrap";
import {TopSelect} from "../../../../componentsTopsa/selects/TopSelects";
import {TopButtonAction} from "../../../../componentsTopsa/buttons/TopButtons";
import OrlenService from "../OrlenService";
import Validator from "../../../../utilities/Validator";
import {TopAlertSukces, TopAlertUwaga} from "../../../../componentsTopsa/alerty/TopAlerts";


export default class OrlenWyslanieFaktury extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nrFaktury: null,
            netto: 0,
            ilosc: 0,
            czyWyslano: false,
            statusWyslania: false,
            setLoader: false,
            showModal: true,
            uwagi: []
        };
        this.onClickWyslij = this.onClickWyslij.bind(this)
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextprops) {
    }

    onClickWyslij() {

        let poprawne = true

        if (!Boolean(this.state.nrFaktury)) {
            poprawne = false;
            alert('Nie wybrano numeru faktury!')
        }

        if (!Validator.validateIntOrDouble(this.state.ilosc)) {
            poprawne = false;
            alert('Podano nieprawidłową wartość netto!')
        } else {
            if (this.state.ilosc <= 0) {
                poprawne = false;
                alert('Wartość netto musi być większa niż 0!')
            }
        }

        if (poprawne) {

            this.setState({
                czyWyslano: true,
                statusWyslania: false,
                setLoader: true,
                showModal: true,
                uwagi: []
            })


            console.log(this.state.nrFaktury.NumerFaktury, this.state.netto.replace(',','.'))


             if(window.confirm('Czy na pewno chcesz wysłać dane?')){
                 OrlenService.wyslijDaneFaktury(this.state.nrFaktury.NumerFaktury, this.state.netto.replace(',','.')).then(function (response) {

                     console.log(response)

                     if (response.status < 300) {

                         console.log('JEST OK')

                         this.setState({
                             statusWyslania: true,
                             setLoader: false,
                             showModal:true,
                         })

                         this.props.handleOdswiezNumeryFaktur();
                     }
                     else {


                         console.log('Status >300')

                         this.setState({
                             statusWyslania: false,
                             setLoader: false,
                             showModal:true,
                         })
                     }

                     if(response.data.length>0){
                         let arr = []

                         for(let i = 0; i<response.data.length;i++){
                             if(Boolean(response.data[i].uwaga)){
                                 arr.push(response.data[i].uwaga)
                             }
                         }

                         this.setState({uwagi:arr})
                     }

                 }.bind(this)).catch(function (err) {
                     this.setState({
                         statusWyslania: false,
                         setLoader: false,
                         showModal:true,
                     })

                     console.log(err)


                     console.log('ERR')

                     console.log(err.status)

                     if(err.data){
                         if(err.data.length>0){
                             let arr = []

                             for(let i = 0; i<err.data.length;i++){
                                 if(Boolean(err.data[i].uwaga)){
                                     arr.push(err.data[i].uwaga)
                                 }
                             }

                             this.setState({uwagi:arr})
                         }
                     }


                 }.bind(this))
             }
        }

    }

    onChooseFaktura(faktura) {
        if (faktura !== null) {
            OrlenService.pobierzPozycjeFaktury(faktura.NumerFaktury).then(function (response) {
                this.setState({ilosc: response.data.ilosc})
            }.bind(this)).catch(function (err) {
                console.log(err)
                this.setState({ilosc: 0})
            }.bind(this))
        }
    }

    renderFakturaOption(option) {
        if (Boolean(this.state.nrFaktury)) {
            return (<div>{option.NumerFaktury}
                <div className={'pull-right'} style={{color: 'grey', fontSize: '12px'}}>Ilość poz.: {this.state.ilosc}</div>
            </div>)
        }
        else return option.NumerFaktury
    }

    render() {

        return (
            <div>
                <Form horizontal={true}>
                    <FormGroup style={{marginBottom: '0', borderLeft: "1px solid #ddd"}}>
                        {/*<Col xs={12} lg={1}></Col>*/}
                        <Col xs={12} lg={5}>
                            <ControlLabel>Wybierz fakturę</ControlLabel>
                            <TopSelect onChange={(e) => {
                                this.setState({
                                    nrFaktury: e,
                                    czyWyslano: false,
                                    statusWyslania: false,
                                    setLoader: false,
                                });
                                this.onChooseFaktura(e)
                            }}
                                       value={this.state.nrFaktury} options={this.props.faktury}
                                       valueKey={'NumerFaktury'} labelKey={'NumerFaktury'}
                                       valueRenderer={(option) => this.renderFakturaOption(option)}
                            />
                        </Col>
                        <Col xs={12} lg={4}>
                            <ControlLabel>Kwota netto</ControlLabel>
                            <FormControl type={'number'} onChange={(e) => this.setState({
                                netto: e.target.value,
                                czyWyslano: false,
                                statusWyslania: false,
                                setLoader: false,
                            })}/>
                        </Col>
                        <Col xs={12} lg={2}>
                            <div className={'add-label-margin'}></div>
                            <TopButtonAction iconType={'fa fa-upload'} onClick={() => this.onClickWyslij()} btnSize={'md'} text={'Wyslij dane'}
                                             btnColor={'info'}/>
                        </Col>
                        {
                            (this.state.czyWyslano) ?
                                <div>
                                    <Col xs={10} lgPush={1} style={{marginTop: '15px'}}>
                                        {
                                            (this.state.setLoader) ?
                                                <div style={{color: 'grey', fontStyle: 'italic'}}>
                                                    <i className={'fa fa-circle-o-notch fa-spin'}></i> Trwa wysyłanie danych...
                                                </div>
                                                :
                                                this.state.statusWyslania ?
                                                    <TopAlertSukces text={'Pomyślnie wysłano dane'}/>
                                                    :
                                                    <TopAlertUwaga text={'Wystąpił błąd podczas wysyłania danych!'}/>
                                        }
                                    </Col>
                                </div>
                                :
                                ''
                        }
                    </FormGroup>
                </Form>
                {
                    this.state.showModal && this.state.czyWyslano ?
                        <div id={'EBUSModalContainerBG'}>
                            <div id={'modalContainer'}>
                                <div id={'modalTextContent'} style={{width: '1000px'}}>
                                    <div>
                                        {
                                            !this.state.setLoader ?

                                                <div className={'pull-right'}>
                                                    <TopButtonAction onClick={() => {
                                                        this.setState({showModal: false})
                                                    }}
                                                                     elementStyle={{color: 'firebrick'}}
                                                                     btnColor={'default'} text={'Zamknij'} iconType={'fa fa-times'}
                                                    />
                                                </div>
                                                :
                                                ''
                                        }

                                        <div style={{clear: 'both', height: '5px'}}></div>
                                        <div>
                                            <div className={'thumbnail'} style={{maxWidth: '966px', maxHeight: '450px'}}>
                                                {
                                                    (this.state.setLoader) ?
                                                        <div style={{color: 'grey', fontStyle: 'italic', fontSize: "20px", padding: 5}}>
                                                            <i className={'fa fa-circle-o-notch fa-spin'}></i> Trwa wysyłanie danych...
                                                        </div>

                                                        :
                                                        <div>
                                                            <h4>Odpowiedź po wysłaniu faktury</h4>
                                                            <div style={{paddingLeft: '5px'}}>
                                                            {
                                                                this.state.statusWyslania ?
                                                                    <TopAlertSukces text={'Pomyślnie wysłano dane'}/>
                                                                    :
                                                                    <TopAlertUwaga text={'Wystąpił błąd podczas wysyłania danych!'}/>
                                                            }
                                                            </div>
                                                            <div style={{padding: '5px', fontFamily: 'monospace', overflow: 'auto'}}>
                                                                {
                                                                    this.state.uwagi.length === 0 ?
                                                                        <div>Brak uwag</div>
                                                                        :
                                                                        <div>
                                                                            <ul>
                                                                                {
                                                                                    this.state.uwagi.map(uwaga => {
                                                                                        return <li>{uwaga}</li>
                                                                                    })
                                                                                }
                                                                            </ul>
                                                                        </div>
                                                                }
                                                            </div>
                                                        </div>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{clear: 'both'}}></div>
                            </div>
                        </div>
                        :
                        ''
                }


            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/Orlen/components/OrlenWyslanieFaktury.js